<div class="sr-feedback" [class.sr-feedback--compact]="compact" *ngIf="canRender"
  (keydown.space)="$event.stopPropagation()"
  (keydown.enter)="$event.stopPropagation()">
  <div class="sr-feedback-header">
    <span class="sr-feedback-label">{{ headerLabel }}</span>
    <po-tag
      *ngIf="showStatusTag"
      class="sr-feedback-status"
      p-value="Pendente"
      p-type="warning"
      p-icon="po-icon-warning">
    </po-tag>
    <!-- Lixeira no cabeçalho, como em "Outras avaliações": remover é ação rara, e um botão
         largo e vermelho embaixo do comentário pesava mais que a própria avaliação. -->
    <po-button
      *ngIf="currentFeedbackId"
      class="sr-feedback-remove"
      p-kind="tertiary"
      p-icon="po-icon-delete"
      p-aria-label="Remover avaliação"
      p-tooltip="Remover avaliação"
      p-tooltip-position="top"
      p-append-in-body="true"
      [p-disabled]="saving || commentSaving"
      (p-click)="onRemoveClick()">
    </po-button>
  </div>

  <div class="sr-feedback-options" role="radiogroup" [attr.aria-label]="headerLabel">
    <po-tag
      *ngFor="let r of resolutions; trackBy: trackByValue"
      class="sr-feedback-option"
      [class.sr-feedback-option--selected]="isSelected(r.value)"
      [class.sr-feedback-option--disabled]="saving"
      [attr.data-resolution]="r.value"
      [p-value]="r.label"
      [p-icon]="r.icon"
      [p-tooltip]="r.label + ' — ' + r.hint"
      p-tooltip-position="top"
      p-append-in-body="true"
      [attr.aria-pressed]="isSelected(r.value)"
      [attr.aria-label]="r.label + ' — ' + r.hint"
      (p-click)="onResolutionClick(r.value)">
    </po-tag>
  </div>

  <div class="sr-feedback-comment" *ngIf="showCommentBox">
    <po-textarea
      class="po-md-12"
      name="feedbackComment"
      [p-placeholder]="commentPlaceholder"
      [p-rows]="compact ? 2 : 3"
      [p-required]="commentRequired"
      [(ngModel)]="comment">
    </po-textarea>
    <!-- Salvar só aparece quando há o que salvar: escolha pendente ou comentário alterado. -->
    <div class="sr-feedback-actions" *ngIf="hasUnsavedChanges">
      <po-button
        p-kind="secondary"
        [p-label]="saveCommentLabel"
        p-icon="po-icon-ok"
        [p-disabled]="!canSaveComment || saving"
        [p-loading]="commentSaving"
        (p-click)="onSaveComment()">
      </po-button>
    </div>
  </div>
</div>
